import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loginUser } from '../../actions/authActions';
import classnames from 'classnames';
import {
    Box,
    Button,
    Card,
    CardContent,
    Container,
    CssBaseline,
    FormControl,
    Grid,
    TextField,
    MenuItem,
    Typography,
    Menu,
} from '@material-ui/core';
import logo from '../../logo-dark.png';
import { makeStyles } from '@material-ui/core/styles';
import Copyright from '../layout/Copyright';
import SosLoginAlert from './SosLoginAlert';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import LanguageIcon from '@material-ui/icons/Language';
import { styled } from '@mui/material/styles';

// Styled menu similar to AppBar
const StyledMenu = styled(props => (
    <Menu
        elevation={3}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        getContentAnchorEl={null}
        style={{ zIndex: 9999 }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: 8,
        minWidth: 180,
        boxShadow: '0px 5px 15px rgba(0,0,0,0.15)',
        zIndex: 9999,
        '& .MuiMenu-list': {
            padding: '8px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                marginRight: theme.spacing(1.5),
            },
        },
    },
}));

const useStyles = makeStyles(theme => ({
    paper: {
        borderRadius: '8px',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    logo_icon: {
        '& .logo-icon': {
            width: '170px',
            margin: theme.spacing(2.5, 6),
            transition: theme.transitions.create(['width'], {
                duration: theme.transitions.duration.shortest,
                easing: theme.transitions.easing.easeInOut,
            }),
        },
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    appBarSpacer: theme.mixins.toolbar,
    textField: {
        margin: theme.spacing(1),
        width: '50vh',
    },
    languageSwitcher: {
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 1100,
    },
}));

class Login extends React.Component {
    constructor() {
        super();
        this.state = {
            nikname: '',
            password: '',
            errors: {},
            language: localStorage.getItem('userLanguage') || 'bg',
            languageMenuAnchorEl: null,
        };
    }

    componentDidMount() {
        // If logged in and user navigates to Login page, should redirect them to dashboard
        if (this.props.auth.isAuthenticated) {
            const userLevel = localStorage.getItem('level');
            if (userLevel === 'fitness') {
                this.props.history.push('/fitness');
            } else {
                this.props.history.push('/cards/offline');
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            const userLevel = localStorage.getItem('level');
            if (userLevel === 'fitness') {
                this.props.history.push('/fitness');
            } else {
                this.props.history.push('/cards/offline');
            }
        }

        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors,
            });
        }
    }

    onChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };

    onSubmit = e => {
        e.preventDefault();

        const userData = {
            nikname: this.state.nikname,
            password: this.state.password,
        };

        this.props.loginUser(userData);
    };

    handleLanguageMenuOpen = event => {
        this.setState({ languageMenuAnchorEl: event.currentTarget });
    };

    handleLanguageMenuClose = () => {
        this.setState({ languageMenuAnchorEl: null });
    };

    changeLanguage = lng => {
        this.setState({ language: lng });
        i18n.changeLanguage(lng);
        localStorage.setItem('userLanguage', lng);
        this.handleLanguageMenuClose();
    };

    render() {
        const {
            appBarSpacer,
            paper,
            logo_icon,
            form,
            submit,
            textField,
        } = this.props;
        const { errors } = this.state;
        const { t } = this.props;

        return (
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                {/* Language Switcher */}
                <div
                    style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        zIndex: 1100,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        color="primary"
                        onClick={this.handleLanguageMenuOpen}
                        startIcon={<LanguageIcon />}
                    >
                        {this.state.language.toUpperCase()}
                    </Button>
                    <StyledMenu
                        anchorEl={this.state.languageMenuAnchorEl}
                        keepMounted
                        open={Boolean(this.state.languageMenuAnchorEl)}
                        onClose={this.handleLanguageMenuClose}
                    >
                        <MenuItem onClick={() => this.changeLanguage('bg')}>
                            {t('auth.bulgarian')}
                        </MenuItem>
                        <MenuItem onClick={() => this.changeLanguage('en')}>
                            {t('auth.english')}
                        </MenuItem>
                        <MenuItem onClick={() => this.changeLanguage('es')}>
                            {t('auth.spanish')}
                        </MenuItem>
                    </StyledMenu>
                </div>

                <Grid
                    item
                    md={12}
                    style={{ alignItems: 'center', paddingTop: '25vh' }}
                >
                    <Card className={paper} style={{ borderRadius: '5px' }}>
                        <CardContent>
                            <div className={logo_icon}>
                                <img
                                    className="logo-icon"
                                    src={logo}
                                    alt="logo"
                                    style={{ width: '200px', margin: '5% 22%' }}
                                />
                            </div>
                            <form
                                className={form}
                                noValidate
                                onSubmit={this.onSubmit}
                            >
                                <FormControl style={{ width: '100%' }}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="nikname"
                                        label={t('auth.username')}
                                        name="nikname"
                                        onChange={this.onChange}
                                        value={this.state.nikname}
                                        error={
                                            errors.nikname ||
                                            errors.niknamenotfound ||
                                            errors.inactiveprofile
                                        }
                                        style={{
                                            marginTop: '8px',
                                            marginBottom: '6px',
                                            width: '100%',
                                        }}
                                        className={classnames('', {
                                            invalid:
                                                errors.nikname ||
                                                errors.niknamenotfound ||
                                                errors.inactiveprofile,
                                        })}
                                        autoComplete="nikname"
                                        autoFocus
                                    />
                                    <span
                                        className="red-text"
                                        style={{ color: 'red' }}
                                    >
                                        {errors.nikname}
                                        {errors.niknamenotfound}
                                        {errors.inactiveprofile}
                                    </span>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label={t('auth.password')}
                                        type="password"
                                        id="password"
                                        onChange={this.onChange}
                                        value={this.state.password}
                                        error={
                                            (errors.password,
                                            errors.passwordincorrect)
                                        }
                                        style={{
                                            marginTop: '8px',
                                            marginBottom: '10px',
                                            width: '100%',
                                        }}
                                        className={classnames('', {
                                            invalid:
                                                errors.password ||
                                                errors.passwordincorrect,
                                        })}
                                        autoComplete="current-password"
                                    />
                                </FormControl>

                                <span
                                    className="red-text"
                                    style={{ color: 'red' }}
                                >
                                    {errors.password}
                                    {errors.passwordincorrect}
                                </span>
                                {/* <FormControlLabel
                            control={<Checkbox value="remember" color="primary" />}
                            label="Remember me"
                        /> */}
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={submit}
                                >
                                    {t('auth.login')}
                                </Button>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
                <Box mt={3}>
                    <Copyright />
                </Box>
                <SosLoginAlert />
            </Container>
        );
    }
}

Login.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors,
});

export default connect(mapStateToProps, { loginUser })(
    withTranslation()(Login)
);
